import { Atom } from "AppReact";
import styled, { css } from "styled-components";

const template = styled.img`
  ${({ theme, displayState }) => css`
    width: ${displayState?.width ?? '50px'};
    min-width: ${displayState?.width ?? '50px'};
    height: ${displayState?.height ?? '50px'};
    min-height: ${displayState?.height ?? '50px'};
    cursor: pointer;
    border-radius: 4px;
    object-fit: cover;
    border: ${displayState?.selected ? `1px solid ${theme?.colour?.primary ?? '#1DBD6B'}` : ''};
    opacity: ${displayState?.selected || displayState?.visible ? 1 : 0.3};
    &:hover {
      opacity: 1;
    }
  `}
`;

export default Atom({ type: 'image', dataType: 'string', template });
